"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaceVerificationRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class FaceVerificationRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('face-verification');
    }
    /**
     * Get a new session token for the verification.
     */
    getToken() {
        return this.get(`/token`, {});
    }
    /**
     * Get the enrollment for the current user.
     *
     * This will return { enrollment: null } if no
     * enrollment is found.
     */
    getEnrollment() {
        return this.get(`/enrollment`, {});
    }
    /**
     * Enroll a user's facemap.
     */
    enroll(facemapUrl, auditTrailUrl, lowQualityAuditTrailUrl, sessionId, userAgent) {
        return this.post(`/enroll`, {
            facemapUrl, auditTrailUrl, lowQualityAuditTrailUrl, sessionId, userAgent
        });
    }
    /**
     * Check if the face on the user's document matches their facemap.
     */
    document(idScanUrl, documentBackUrl, documentFrontUrl, sessionId, userAgent) {
        return this.post(`/document`, {
            idScanUrl,
            documentBackUrl,
            documentFrontUrl,
            sessionId,
            userAgent
        });
    }
    /**
     * Submit a BVN
     */
    submitBvn(bvn) {
        return this.post(`/bvn`, { bvn });
    }
    /**
     * Get a new session token for the verification.
     */
    getLicense() {
        return this.get(`/license`, {});
    }
}
exports.FaceVerificationRoutes = FaceVerificationRoutes;
//# sourceMappingURL=face-verification.js.map